import { useTranslation } from 'react-i18next';
import { Box, Button, CircularProgress, Grid2 } from '@mui/material';

const ActionButtons = ({ handleSubmit, handleClose, submitting, labelNext = '', disabled = false }) => {
    const { t: translate } = useTranslation();

    return (
        <Grid2 container justifyContent={{ xs: 'center', md: 'flex-end' }} alignItems="center" gap="12px" mt="16px">
            <Button
                sx={{
                    padding: '8px 14px',
                    borderColor: '#13131340',
                    fontWeight: 700,
                    width: { xs: '100%', md: 'fit-content' },
                    textTransform: 'none',
                }}
                variant="outlined"
                onClick={handleClose}
            >
                {translate('price_group_id.action_button.cancel')}
            </Button>
            <Button
                sx={{
                    padding: '8px 14px',
                    backgroundColor: 'var(--color-utriper-blue)',
                    fontWeight: 700,
                    width: { xs: '100%', md: 'fit-content' },
                    textTransform: 'none',
                }}
                loading={submitting}
                loadingIndicator={
                    <Box sx={{ display: 'flex' }}>
                        <CircularProgress size={20} sx={{ color: '#131313bf' }} />
                    </Box>
                }
                disabled={disabled}
                variant="contained"
                type="submit"
                onClick={handleSubmit}
            >
                {labelNext}
            </Button>
        </Grid2>
    );
};

export default ActionButtons;
